import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'audit-report-management',
    template: require('./audit-report-management.html')
})

export class AuditReprotManagementComponent implements OnInit {

    ngOnInit(): void {
        
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/audit-report/audit-report-management.component.ts